import { render, staticRenderFns } from "./ValidForm.vue?vue&type=template&id=1b8f2965&scoped=true&"
import script from "./ValidForm.vue?vue&type=script&lang=js&"
export * from "./ValidForm.vue?vue&type=script&lang=js&"
import style0 from "./ValidForm.vue?vue&type=style&index=0&id=1b8f2965&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f2965",
  null
  
)

export default component.exports